import { Skeleton } from "@/components/ui/skeleton";

export const DietSkeleton = () => {
  return (
    <div className="my-4 flex flex-col gap-4 md:flex-row">
      <Skeleton className="h-44 w-full rounded-xl md:w-[240px]" />
      <div className="flex grow flex-col md:py-4">
        <div className="hidden gap-4 md:flex">
          <Skeleton className="h-[64px] w-[64px] rounded-lg" />
          <div className="flex flex-1 flex-col gap-2">
            <Skeleton className="h-8 w-full" />
            <div className="flex gap-2">
              <Skeleton className="h-6 flex-1" />
              <Skeleton className="h-6 flex-1" />
            </div>
          </div>
        </div>
        <div className="flex gap-2 md:hidden">
          <Skeleton className="h-8 flex-1" />
          <Skeleton className="h-8 flex-1" />
        </div>
        <Skeleton className="mt-2 h-10 w-full md:hidden" />
        <div className="mt-2 flex gap-10 md:mt-auto">
          <Skeleton className="h-8 flex-1" />
          <Skeleton className="hidden h-10 flex-1 md:block" />
        </div>
      </div>
    </div>
  );
};
